/**
 * Search-focus target registry.
 *
 * Lets the global `⌘K` handler focus whatever search input the current page
 * exposes without the keyboard core importing page components. A page registers a
 * focuser on mount (returning `true` if it focused something); `focus()` tries
 * the registered targets and reports whether any handled it, so the global
 * handler only claims the key when it can act.
 */

type SearchFocuser = () => boolean;

const focusers = new Set<SearchFocuser>();

export const searchTarget = Object.freeze({
  register(focuser: SearchFocuser): () => void {
    focusers.add(focuser);
    return () => {
      focusers.delete(focuser);
    };
  },
  focus(): boolean {
    for (const focuser of focusers) {
      if (focuser()) return true;
    }
    return false;
  },
});
